// @flow

import React from 'react'
import { useTranslation } from 'react-i18next'
import { ParentEnum } from '@bfg/enums/ParentEnum'
import { Parent } from '@bfg/components/utils/Parent'

const parent = ParentEnum.firstParent
const FirstParent = (props: any) => {
  const { i18n } = useTranslation()
  return (<>
    <Parent parent={parent}
            subscriberId={props.subscriberId}
    />
    {[
      'en',
      'baby-GENERATOR',
      'what-will-my-baby-look-like',
      'what-will-our-baby-look-like',
      'what-would-our-baby-look-like'
    ].includes(i18n.language) && (<>
      <div className="spacer" style={{ marginBottom: '50px' }}/>
      <SeoText/>
    </>)}
  </>)
}
const SeoText = () => {
  const { t, i18n } = useTranslation()

  const picsList = [
    { alt: 'pic1alt', src: '/img/bfg-image-1.jpg', },
    { alt: 'pic2alt', src: '/img/bfg-image-2.jpg', },
    { alt: 'pic3alt', src: '/img/bfg-image-3.jpg', },
    { alt: 'pic4alt', src: '/img/bfg-image-4.jpg', },
  ]
  const hiddenRef = React.useRef()
  const linkRef = React.useRef()
  const picsRef = React.useRef([])
  const showHidden = (e) => {
    e.preventDefault()
    hiddenRef.current.classList.remove('hidden')
    linkRef.current.classList.add('hidden')
    for (let picRef of picsRef.current) {
      picRef.setAttribute('src', picRef.getAttribute('data-src'))
    }
  }
  return (
    <>
      <div className="small-print">
        <small>
          <p>
            {t('seo.small.part1')}
          </p>
          <p onClick={showHidden} ref={linkRef}>
            <br/>
            <a onClick={showHidden}>Read More</a>
            <br/>
          </p>
        </small>
        <div className={`hidden`} ref={hiddenRef}>
          <small>
            <br/>
            <p>
              {t('seo.small.part2')}
            </p>
            {i18n.language === 'en' && <>
              <br/>
              <p>
                What will my baby look like? This question can be answered by simply uploading two photos. Learn more
                about how it works below and create your future infant in just a few seconds!
              </p>
            </>}
            <br/>
            <h2>{t('seo.small.h2')}</h2>
            {i18n.language === 'en' && <>
              <br/>
              <p>
                The Baby Maker is a baby generator online web application - it works anytime, anywhere and on any
                device, to allow users from all over the world to generate babies within minutes! To create a baby you
                need to upload your picture and a picture of your partner. You can even make babies with the most famous
                celebrities - the Baby Face Generator website has a built-in database of ready-made celebrity photos!
              </p>
              <br/>
              <h2>Baby Face Generator</h2>
            </>}
            <br/>
            <p>
              {t('seo.small.part3')}
            </p>
            <br/>
            <p>
              {t('seo.small.part4')}
            </p>
            {i18n.language === 'en' && <>
              <br/>
              <p>
                You can manage settings to customize your baby's face by choosing a skin tone, or let the algorithm
                automatically detect and match it with your faces. As for the gender, you can pick a boy or a girl, or
                simply let us surprise you with a created baby!
              </p>
              <br/>
              <h2>What Will Our Baby Look Like</h2>
              <br/>
              <p>
                Don't waste your time guessing “what would my baby look like?”. Simply upload a picture of yourself and
                your partner to create your future baby! It takes less than 2 minutes and only a few mouse clicks to
                generate a photo with the help of our online app. Go ahead and check the results yourself! In case you
                have any questions or suggestions, we are always glad to hear from you!
              </p>
              <br/>
              <h2>Instructions</h2>
              <br/>
              <p>
                Below you will find a list of instructions that will help you to create your future baby in just a few
                minutes. As the baby's face is generated automatically by the artificial intelligence and we can not
                edit the result manually, please make sure to follow the steps below to “help” the technology create the
                most precise baby picture for you.
              </p>
              <br/>
              <ul>
                <li>Upload high-quality photos or take high-quality selfies</li>
                <li>Your face and the face of your partner should be frontal, with no glasses or hair covering the
                  face
                </li>
                <li>Make sure your face is clearly visible and it occupies as much space on the photo as possible</li>
                <li>If you wish to generate a baby with a celebrity, simply pick one from our library (we have movie
                  stars, athletes, musicians, and even Youtube celebrities)
                </li>
                <li>It's easier to find a celebrity when using Search (simply enter a name or a surname to select a
                  celebrity)
                </li>
                <li>Baby customization settings include baby's name, skin tone and gender</li>
                <li>You can always change customization settings to generate a new baby</li>
                <li>You can create as many babies as you want while your premium membership is active</li>
                <li>You can download baby photos to your computer or phone, or easily share them with your friends or
                  family through social networks
                </li>
                <li>We are always here to help, so in case you have any questions or concerns, simply contact us by
                  using the Contact Us page
                </li>
              </ul>
            </>}
            <br/>
            {picsList.map((pic, id) => {
              return (
                <div key={id}
                     className={`main-page-pic`}
                >
                  <img data-src={pic.src}
                       alt={t(`seo.${pic.alt}`)}
                       ref={el => picsRef.current[id] = el}
                  />
                </div>
              )
            })}
          </small>
        </div>
      </div>
    </>
  )
}

export default FirstParent

